

























import { useCarousel } from './carousel';
import AppSvgIcon from '@/uikit/components/AppSvgIconNew/AppSvgIcon.vue';

export default {
  components: { AppSvgIcon },
  props: {
    lineTitleColor: {
      default: '#279DF2',
    },
    title: {},
    flexWrap: {
      default: false,
    },
  },
  data() {
    return {
      carousel: {} as ReturnType<typeof useCarousel>,
    };
  },
  computed: {
    getStyle() {
      let ret: any = {};
      if (this.flexWrap) {
        ret['--display-list'] = 'flex';
      }
      return ret;
    },
    isContent() {
      return this.$slots.default && this.$slots.default.length;
    },
  },
  mounted() {
    this.carousel = useCarousel({
      wrapElem: this.$refs.carouselWrapper,
      isLoop: true,
    });
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/components/parts/slider/StartPageSlider.vue